/**
* reducers for the all components
*
* Created by Tom on 23/05/18
*/

import C from '../constants'

const initState = {
    openLeftMenu: false,
    openRightMenu: false,
    openCongratsInfo: true,
    onTour: false,
}

export const componentState = (state = initState, action) => {

    switch(action.type) {

        // in case of `openLeftMenu` change
        case C.SET_OPEN_LEFT_MENU :
            return {
                ...state,
                openLeftMenu: action.payload
            }

        // in case of `openRightMenu` change
        case C.SET_OPEN_RIGHT_MENU:
            return {
                ...state,
                openRightMenu: action.payload
            }

        // in case of `openCongratsInfo` change
        case C.SET_OPEN_CONGRATS_INFO:
            return {
                ...state,
                openCongratsInfo: action.payload
            }

        // in case of 'onTour' change
        case C.SET_ON_TOUR:
            return {
                ...state,
                onTour: action.payload
            }

        case C.SET_ON_TOUR_HIGHLIGHT:
            return {
                ...state,
                onTourHighlight: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/componentReducers.js